<template lang="pug">
  v-layout.card-number-background(
    column
    align-center
    @click="SelectButton"
    :class="hoverMethod"
    :style="{'background':cardBackgroundColor}"
    )
    v-flex.card-content-align
      p
        span.card-number-text.box-number-description {{textNumber || '0'}}
        span.card-number-text.box-text-description(:style="{'width': cardBackgroundColor ? '5em' : ''}") {{description || 'Periodo de Pago'}}
</template>

<script>
export default {
  props: [
    'textNumber',
    'description',
    'cardBackgroundColor',
    'hoverButton'
  ],
  methods: {
    SelectButton () {
      this.$emit('selectButton', this.description.toLowerCase())
    }
  },
  computed: {
    hoverMethod () {
      return this.hoverButton ? 'box-card-number-hover' : ''
    }
  }
}
</script>

<style scoped>
@media (min-width: 360px) {

  .card-number-background {
    background: #0855C4;
    border-radius: 4px;
    width: 6.8em;
    height: 3.8em;
    margin: 0.5em;
    padding-top: 0.2em !important;
  }

  .card-number-background .card-content-align {
    display: flex;
    align-items: center;
  }

  .card-number-background p {
    margin: 0.1em;
    transition: 0.1s;
  }

  .box-card-number-hover:hover p {
    transform: scaleX(1.05);
    transition: 0.1s;
  }

  .card-number-text {
    display: block;
    text-align: center;
    color: #ffffff
  }

  .box-text-description {
    line-height: 0.9;
    font-size: 13px;
    width: 4em;
    margin: 0 auto;
    margin-top: 2px
  }

  .box-number-description {
    line-height: normal !important;
    font-size: 17px;
  }
}

@media (min-width: 390px) {
  .card-number-background {
    width: 7em;
    height: 4em;
    padding: 0.2em 0em !important;
  }
}

@media (min-width: 1024px) {

  .card-number-background {
    width: 5.6em !important;
    height: 3.9em !important;
  }

  .card-number-background p {
    margin: 0 !important;
  }

  .box-text-description {
    font-size: 13px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generic/CardNumberText.vue